export const locale = {
    lang: "es-ES",
    data: {
        NOTIFICATION: {
            TITLE: "Notificación",

            APP_HAS_NOTIFICATIONS: "¡Tienes {{count}} notificaciones en la aplicación!",
            APP_HAS_NOTIFICATION: "¡Tienes 1 notificación en la aplicación!",
            GO_TO_APP: "Ir a la aplicación",

            CERTIFICATE_EXPORT_COMPLETED: "¡Certificados exportados con éxito!",
            USER_IMPORT_SUCCESS: "Usuarios importados con éxito!",
            USER_EXPORT_COMPLETED: "Usuarios exportados con éxito!",
            DOWNLOAD: "DESCARGAR"
        }
    }
};
